import { createSelector } from "@ngrx/store";
import type { AppState } from "@store";

const selectFuturesChallengesState = (state: AppState) => state.futuresNewChallenge;

export const selectFuturesNewChallenge = createSelector(
  selectFuturesChallengesState,
  (state) => state.newChallenge,
);
